import NsContent from 'components/common/ns-content/NsContent';
import NsDownload from '@britishgasenergy/react-nucleus/dist/nuc-components/NsDownload';

import { NsInputterValidations } from 'components/common/ns-inputter/NsInputterValidations';
import { NsCheckboxInput } from 'components/common/ns-checkbox-input/NsCheckboxInput';
import DirectDebitLogo from 'assets/images/direct-debit.svg';

export const DirectDebitGuarantee = () => {
  return (
    <>
      <NsContent>
        <h5 data-testid="ddGuaranteeTitle">Direct Debit Guarantee</h5>
        <p>
          By pressing &apos;Check your order&apos; you declare that you are the
          only person required to authorise a Direct Debit for this account.
          Your prices are lower with Direct Debit, so if you move to a different
          payment method your prices will increase.
        </p>
      </NsContent>
      <img
        src={DirectDebitLogo}
        width="145.22"
        height="47"
        alt="Direct Debit Logo"
      />
      <NsDownload href="/aem6/content/dam/britishgas/documents/Direct-Debit-Guarantee.pdf">
        Direct Debit Guarantee{' '}
      </NsDownload>
      <NsCheckboxInput
        name="terms"
        testId="ddGuaranteeTestId"
        options={[
          {
            label: 'I’ve read and understood the Direct Debit Guarantee.',
            value: 'true'
          }
        ]}
        validation={[NsInputterValidations.isRequired]}
      />
    </>
  );
};
